import React, { useState } from "react";
import { AnimatePresence,spring, motion, transform } from "framer-motion";

const Footer = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isShopOpen, setShopOpen] = useState(false);
  const menuVariants = {
    open: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        transform: spring(0.5,0.8),
      },
    },
    closed: {
      opacity: 0,
      y: "100%",
      transition: {
        duration: 0.3,
        transform: "translateX(-100%) translateX(100%)",
      },
    },
  };

  return (
    <>
    <div>
      
      <div className="footer-nav">
        <div className="contact-info">
          <span>
            <i className="fas fa-envelope"></i> info@mevedir.com
          </span>
          <span>
            <i className="fas fa-phone"></i> +91 97331 80740 / 9434750860
          </span>
        </div>

        <div
          className={`hamburger ${isMenuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!isMenuOpen)}
        >
          <i className={`fa ${isMenuOpen ? "fa-times" : "fa-bars"}`} />
        </div>

      </div>
        <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="menu"
            initial="closed"
            animate="open"
            exit="closed"
            variants={menuVariants}
          >
            <ul>
              <li>
                <a href="#section1" onClick={() => setMenuOpen(false)}>
                  Home
                </a>
              </li>
              <li>
                <a href="#section2" onClick={() => setMenuOpen(false)}>
                  About
                </a>
              </li>
              <li>
                <a href="#section3" onClick={() => setMenuOpen(false)}>
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" onClick={() => setMenuOpen(false)}>
                  Contact
                </a>
              </li>
              <li>
                <a href="/products">Products</a>
              </li>
              <li>
                <div
                  className="submenu-trigger"
                  onClick={() => setShopOpen(!isShopOpen)}
                >
                  <span>Shop</span>
                  <i
                    className={`fa ${
                      isShopOpen ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </div>
                {isShopOpen && (
                  <ul className="submenus">
                    <li>
                      <a
                        href="https://www.himalayfrsh.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Himalay Frsh
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.vartohorganic.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Vartoh Organic
                      </a>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </motion.div>
        )}
        </AnimatePresence>
      
    </div>
    </>
  );
};

export default Footer;
